class PageController {
	
	constructor(){
    	this.body = document.getElementsByTagName("body")[0];
    }
	
	getBody(){
		return this.body;
	}
	
}
